export default {
    format(number){
        if(!number)
            return "00.0"

        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
}